module.exports = __webpack_public_path__ + "img/PPT版_00.a3781619.png";